import { render, staticRenderFns } from "./btn_default.vue?vue&type=template&id=7bafddba&scoped=true&"
import script from "./btn_default.vue?vue&type=script&lang=js&"
export * from "./btn_default.vue?vue&type=script&lang=js&"
import style0 from "./btn_default.vue?vue&type=style&index=0&id=7bafddba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bafddba",
  null
  
)

export default component.exports